// The icon a folder gets from its subject, same table as iOS
// (`FolderSubjectTheme.swift`). A folder document may carry the subject the
// iOS app chose (`subject`: key, "" for a plain folder); otherwise the name
// is matched against these keywords, accents and case folded.

const TABLE = [
  ["math", ["math", "mathe", "matem", "algebr", "geometr", "calcul", "analy"], "subjectMath"],
  ["physics", ["physi", "fisic", "physik", "mecani", "mechani"], "subjectPhysics"],
  ["chemistry", ["chimi", "chem", "quimi", "chimica"], "subjectChemistry"],
  ["biology", ["bio", "svt", "natur", "botan", "anatom"], "subjectBiology"],
  ["history", ["hist", "geschicht", "storia"], "subjectHistory"],
  ["geography", ["geo", "geograf", "erdkund"], "subjectGeography"],
  ["languages", ["anglais", "english", "englisch", "espagnol", "spanish", "deutsch", "allemand", "italien", "langu", "idiom", "sprach"], "subjectLanguages"],
  ["literature", ["franc", "litt", "liter", "lettre", "lecture", "philo"], "subjectLiterature"],
  ["computing", ["info", "code", "program", "comput", "algo", "python", "swift", "java", "web", "dev"], "subjectComputing"],
  ["economics", ["eco", "finan", "gestion", "compta", "business", "market", "droit", "law", "recht"], "subjectEconomics"],
  ["music", ["music", "musiq", "musik"], "subjectMusic"],
  ["art", ["art", "dessin", "design", "kunst", "photo"], "subjectArt"],
  ["sport", ["sport", "eps", "fitness", "gym"], "subjectSport"],
  ["medicine", ["medec", "medic", "sante", "health", "pharma", "nurs", "infirm"], "subjectMedicine"],
  ["psychology", ["psych"], "subjectPsychology"],
  ["engineering", ["ingen", "engin", "electro", "meca", "robot"], "subjectEngineering"],
  ["cooking", ["cuisin", "cook", "recette", "recipe"], "subjectCooking"],
  ["travel", ["voyage", "travel", "trip"], "subjectTravel"],
  ["work", ["travail", "work", "job", "boulot", "pro", "reunion", "meeting"], "subjectWork"],
  ["personal", ["perso", "personal", "journal", "idee", "idea", "privat"], "subjectPersonal"],
];

const BY_KEY = Object.fromEntries(TABLE.map(([key, , icon]) => [key, icon]));

function fold(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();
}

/** An SfIcon name for the folder, or null when it has no subject. */
export function folderSubjectIcon(folder) {
  if (!folder) return null;
  if (typeof folder.subject === "string") {
    return BY_KEY[folder.subject] || null;
  }
  const name = fold(folder.name);
  const match = TABLE.find(([, keywords]) => keywords.some((k) => name.includes(k)));
  return match ? match[2] : null;
}
